import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { DishServices } from '../../../dish/services';
import { StaticsServices } from '../../../services/statics';

/**
 * Generated class for the SelectBetweenDatetime page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-select-date-tk-pickup-day',
  templateUrl: 'select-date-tk-pickup-day.html',
})
export class SelectDateTkPickupDay {
  tk_pickup_day: any;
  element: any;
  type: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public globals: Globals,
    public translate: TranslateService,
    public toastCtrl: ToastController,
    public dishServices: DishServices,
    public staticsServices: StaticsServices) {

    this.type = this.navParams.get('type');
    this.element = this.navParams.get('element');
    var date = this.navParams.get('tk_pickup_day');

    if (date != undefined) {
      date = date.split('/');
      this.tk_pickup_day = date[2] + '-' + date[1] + '-' + date[0];
    } else {
      this.tk_pickup_day = '';
    }
  }

  close() {
    this.viewCtrl.dismiss();
  }

  save() {
    //Guardar la nueva fecha
    if (this.tk_pickup_day) {
      if (this.type == 'dish') {
        this.dishServices.afs.collection('dish').doc(this.element.UID).update({
          'tk_pickup_day': moment(this.tk_pickup_day).format('DD/MM/YYYY'),
        });
      } else if (this.type == 'menu') {
        this.dishServices.afs.collection('menus').doc(this.element.UID).update({
          'tk_pickup_day': moment(this.tk_pickup_day).format('DD/MM/YYYY'),
        });
      }
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-guardado-correctamente'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
      this.close();
      this.staticsServices.changeStateStaticWait(true);
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-selecciona-fecha'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  delete() {
    //Limpiar la variable
    if (this.type == 'dish') {
      this.dishServices.afs.collection('dish').doc(this.element.UID).update({
        'tk_pickup_day': '',
      });
    } else if (this.type == 'menu') {
      this.dishServices.afs.collection('menus').doc(this.element.UID).update({
        'tk_pickup_day': '',
      });
    }

    let toast = this.toastCtrl.create({
      message: this.translate.instant('general-eliminado-correctamente'),
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
    this.close();
    this.staticsServices.changeStateStaticWait(true);
  }
}



// WEBPACK FOOTER //
// ./src/pages/components/popups/select-date-tk-pickup-day/select-date-tk-pickup-day.ts